var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03773 10.0454C4.03773 7.07158 6.4485 4.66081 9.42234 4.66081C12.3962 4.66081 14.807 7.07158 14.807 10.0454C14.807 11.4966 14.2329 12.8137 13.2994 13.782C13.2734 13.8021 13.2484 13.8241 13.2245 13.8479C13.2006 13.8718 13.1787 13.8968 13.1586 13.9228C12.1903 14.8561 10.8734 15.43 9.42234 15.43C6.4485 15.43 4.03773 13.0193 4.03773 10.0454ZM13.7434 15.4547C12.5591 16.402 11.0569 16.9685 9.42234 16.9685C5.59883 16.9685 2.49927 13.8689 2.49927 10.0454C2.49927 6.22191 5.59883 3.12234 9.42234 3.12234C13.2459 3.12234 16.3454 6.22191 16.3454 10.0454C16.3454 11.6801 15.7788 13.1825 14.8313 14.3669L17.6585 17.1941C17.9589 17.4945 17.9589 17.9816 17.6585 18.282C17.3581 18.5824 16.8711 18.5824 16.5706 18.282L13.7434 15.4547Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeach);
export default __webpack_public_path__ + "static/media/icon-seach.00722e11347b63b8ef2e352535c845a0.svg";
export { ForwardRef as ReactComponent };